/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type IllegalContentReportViewContainer_settings = {
    readonly " $fragmentRefs": FragmentRefs<"UserBoxContainer_settings" | "CommentContainer_settings">;
    readonly " $refType": "IllegalContentReportViewContainer_settings";
};
export type IllegalContentReportViewContainer_settings$data = IllegalContentReportViewContainer_settings;
export type IllegalContentReportViewContainer_settings$key = {
    readonly " $data"?: IllegalContentReportViewContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"IllegalContentReportViewContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "IllegalContentReportViewContainer_settings",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserBoxContainer_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_settings"
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '0bf205f7cca933a7ab2fdb5f8e6594f6';
export default node;
